import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';

import { Modal } from 'components';

import { ConfirmProps } from './types';

import * as S from './styles';

const Confirm: React.FC<ConfirmProps> = ({ modalKey, props, isOpen }) => {
  const { closeModal } = useModals();
  const {
    message,
    onConfirm,
    cancelLabel,
    confirmLabel = 'CONFIRM.CONFIRM.DEFAULT',
    instructs,
    hideIcon = true,
  } = props;

  return (
    <Modal isOpen={isOpen} closeModal={() => closeModal(modalKey)}>
      <S.Container
        onSubmit={e => e.preventDefault()}
        data-testid="confirmContainer"
      >
        {!hideIcon && <S.StyledAlertTriangle />}
        <S.Body>
          <S.Message data-testid="confirmMessage">
            {typeof message === 'string' ? (
              <FormattedMessage id={message} />
            ) : (
              message
            )}
          </S.Message>
        </S.Body>
        {instructs && (
          <S.Instructions data-testid="confirmInstructions">
            <FormattedMessage id={instructs} />
          </S.Instructions>
        )}
        <S.ConfirmActions>
          {cancelLabel && (
            <S.CancelButton
              data-testid="cancelButton"
              onClick={() => closeModal(modalKey)}
            >
              <FormattedMessage id={cancelLabel} />
            </S.CancelButton>
          )}
          <S.AcceptButton
            data-testid="acceptButton"
            type="button"
            onClick={() => {
              closeModal(modalKey);
              onConfirm();
            }}
          >
            <FormattedMessage id={confirmLabel} />
          </S.AcceptButton>
        </S.ConfirmActions>
      </S.Container>
    </Modal>
  );
};

export default Confirm;
